import Automatic from './Automatic.js';
export default Automatic;
